import { InteractionRequiredAuthError, type IPublicClientApplication } from '@azure/msal-browser'

/**
 * The signed-in user's access token for `scopes`, or `null` when there is no signed-in user or
 * a silent renewal fails. Send the request without a token in that case; the API's 401 is what
 * the app reacts to.
 *
 * Only MSAL's own "needs interactive sign-in" error redirects to B2C. A network blip or B2C
 * hiccup during silent renewal must not bounce a user who is still validly signed in out of
 * the app mid-task.
 */
export async function getAccessToken(
  msal: IPublicClientApplication,
  scopes: string[],
): Promise<string | null> {
  const account = msal.getActiveAccount() ?? msal.getAllAccounts()[0]
  if (!account) return null

  try {
    const result = await msal.acquireTokenSilent({ scopes, account })
    return result.accessToken
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msal.acquireTokenRedirect({ scopes, account })
    }
    return null
  }
}
